import {
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  Loading,
  MaskedInput,
  IconButton,
  Button,
  TextField,
} from "../../../../../components";
import { useEffect, useState } from "react";
import {
  AdzapService,
  CondicionaisService,
  MensagemPersonalizadaService,
  notification,
  SessionService,
} from "../../../../../services";
import { responseErros, voltar } from "../../../../../utils";
import { InputErros } from "../../../../../helpers";
import { condicionalPdfValidator } from "../../middlewares";

const condicionaisService = new CondicionaisService();
const adzapService = new AdzapService();
const mensagemPersonalizadaService = new MensagemPersonalizadaService();
const sessionService = new SessionService();

const EnvioWhatsappDialog = ({ open, setOpen, data, initialCollapses }) => {
  const [loading, setLoading] = useState(false);
  const [celular, setCelular] = useState("");
  const [nomeCompletoCliente, setNomeCompletoCliente] = useState("");
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const usuario = sessionService.getUsuario();

  useEffect(() => {
    if (open && data.cliente?.id) {
      setCelular(data.cliente?.celular);
      setNomeCompletoCliente(data.cliente?.nomeRazaoSocial);
    }
  }, [open]);

  const handleInputChange = (event) => {
    setCelular(event.target.value);
  };

  function handleCloseDialog() {
    setCelular("");
    setOpen(false);
    initialCollapses();
    voltar();
  }

  const aspectRatioLogoEmpresa = () => {
    const img = document.getElementById("whats");
    const aspectRatio = (img.naturalWidth || 1) / (img.naturalHeight || 1);
    return aspectRatio <= 1.5 ? 100 : 20;
  };

  async function handleSubmit() {
    setLoading(true);
    condicionalPdfValidator
      .validate(data, { abortEarly: false })
      .then(async () => {
        const aspectRatio = aspectRatioLogoEmpresa();
        const result = await condicionaisService.pdf({
          ...data,
          empresa: {
            ...data.empresa,
            aspectRatio,
          },
        });
        if (!result.isAxiosError) {
          if (result.data) {
            await enviarPdf(result.data);
          }
        } else {
          setLoading(false);
          responseErros(result);
        }
      })
      .catch((err) => {
        inputErros.set(err);
        setLoading(false);
      });
  }

  async function enviarPdf(dadosArquivo) {
    try {
      let text = "Segue condicional solicitada!";
      const getPrimeiroNome = (nomeCompleto) => {
        return nomeCompleto?.split(" ")[0] || "";
      };
      const nomeCliente = data?.cliente?.nomeRazaoSocial || nomeCompletoCliente;
      const texto = await mensagemPersonalizadaService.getMensagem({
        contexto: "condicional",
        apelidoFantasia: data?.empresa?.fantasia,
        numeroDocumento: data?.codigo,
        status: data?.status,
        dataVencimento: data?.dataVencimentoFormat,
        nomeCompletoCliente: nomeCliente,
        primeiroNomeCliente: getPrimeiroNome(nomeCliente),
        nomeUsuario: usuario?.nome,
      });

      if (!texto.isAxiosError) {
        text = texto.data;
      } else {
        return responseErros(texto);
      }

      const result = await adzapService.enviarMensagem({
        number: celular,
        type: "document",
        file: dadosArquivo.file,
        docName: dadosArquivo.docName,
        text,
      });

      if (!result.isAxiosError) {
        handleCloseDialog();
        notification.sucessoGenericos("Condicional enviada com sucesso!");
      } else {
        handleCloseDialog();
        responseErros(result);
      }
    } catch (error) {
      notification.erroGenericos("Falha no envio do documento");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={open}
        onClose={() => handleCloseDialog()}
      >
        <CardHeader title="Envio Whatsapp" className="m-2" />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="nomeCompletoCliente"
                name="nomeCompletoCliente"
                label="Nome"
                variant="outlined"
                fullWidth
                value={nomeCompletoCliente}
                onChange={(e) => setNomeCompletoCliente(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={true}>
                      <i
                        className="ph-fill ph-user"
                        style={{ fontSize: 20 }}
                      ></i>
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MaskedInput
                id="celular"
                name="celular"
                label="Celular"
                mask="(99) 9 9999-9999"
                onChange={handleInputChange}
                margin="none"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={true}>
                      <i
                        className="ph-fill ph-device-mobile"
                        style={{ fontSize: 20 }}
                      ></i>
                    </IconButton>
                  ),
                }}
                value={celular ? celular : ""}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => handleSubmit()}
              >
                Enviar Condicional
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <Loading loading={loading} />
      </Dialog>
    </>
  );
};

export default EnvioWhatsappDialog;
